/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 4/1/21.
 */

function FileProgressModalComponent(
    this: JS5Object,
    _: JS5Object,
    uiGridConstants: JS5Object,
    Rx: JS5Object,
    FileProgressService: JS5Object,
) {

    //======//
    // Grid //
    //======//

    this.gridOptions = {
        data: null,
        enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
        enableRowHeaderSelection: false,
        enableRowSelection: true,
        enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
        multiSelect: false,
        rowSelection: true,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
        columnDefs: [{
            field: 'status',
            name: 'statusIcon',
            displayName: '',
            width: '35',
            enableSorting: false,
            enableColumnMenu: false,
            enableColumnResizing: false,
            enableFiltering: false,
            cellTemplate: 'components/modal/fileProgressModal/cellTemplates/upload-status-cell-template.html',
        }, {
            field: 'filename',
            displayName: 'File',
            enableColumnMenu: false,
            enableFiltering: false,
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
        }, {
            field: 'targetPackageId',
            displayName: 'Package',
            width: '90',
            enableColumnMenu: false,
            enableFiltering: false,
            cellTemplate: 'components/modal/fileProgressModal/cellTemplates/target-package-link-cell-template.html',
        }, {
            field: 'progress',
            displayName: 'Upload Progress',
            width: '15%',
            enableColumnMenu: false,
            enableFiltering: false,
            cellTemplate: 'components/modal/fileProgressModal/cellTemplates/upload-progress-cell-template.html',
        }, {
            field: 'dateStarted',
            displayName: 'Date Started',
            width: '250',
            enableColumnMenu: false,
            enableFiltering: false,
            cellFilter: 'amDateFormat:"MMM, D, YYYY, h:mm:ss A"',
            sort: {direction: uiGridConstants.DESC},
        }],
    };


    //================//
    // Template Logic //
    //================//

    this.onPackageNavigationStarted = () => {
        this.loadingIndicator.show = true;
    };

    this.onPackageNavigationEnded = () => {
        this.loadingIndicator.show = false;
    };

    this.updateRowFilter = () => {
        this.gridOptions.data = [];
        this.endObservable.onNext();
        updatePendingFiles();
    };

    this.clearCompletedUploads = () => {
        FileProgressService.clearCompletedUploads();
        this.updateRowFilter();
    };

    this.close = () => {
        this.dismiss({$value: 'cancel'});
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    const updatePendingFiles = () => {
        // TODO: Add button to clear completed => Don't re-add cleared & completed rows
        let newUploadInfos = (this.showCompleted) ? [...FileProgressService.getAllUploads()] : [...FileProgressService.getPendingUploads()];
        _.forEach(this.gridOptions.data, (currentRow: JS5Object) => {
            let matchingUploadIndex = newUploadInfos.indexOf(currentRow.uploadInfo);
            if (matchingUploadIndex >= 0) {
                newUploadInfos.splice(matchingUploadIndex, 1);
            }
        });
        _.forEach(newUploadInfos, (newUploadInfo: JS5Object) => {
            console.log(newUploadInfo);
            let newRow = {
                status: newUploadInfo.status,
                filename: newUploadInfo.filename,
                targetPackageId: newUploadInfo.targetPackageId,
                dateStarted: newUploadInfo.dateStarted,
                uploadInfo: newUploadInfo,
                progress: Math.floor(newUploadInfo.progressObservable.value * 100),
            };
            this.gridOptions.data.push(newRow);
            const observable = newUploadInfo.progressObservable.takeUntil(this.endObservable);
            observable.subscribeOnNext((progress: number) => {
                newRow.status = newUploadInfo.status;
                newRow.progress = Math.floor(progress * 100);
            });
            observable.subscribeOnCompleted(() => {
                newRow.status = newUploadInfo.status;
            });
        });
    };

    this.$onInit = () => {
        this.endObservable = new Rx.Subject();
        this.showCompleted = true;
        this.gridOptions.data = [];
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        this.packageIdList = ['(placeholder)'];
        updatePendingFiles();
    };

    this.$doCheck = () => {
        if (this.gridOptions.data) {
            updatePendingFiles();
        }
    };

    this.$onDestroy = () => {
        this.endObservable.onCompleted();
    };
}

angular.module('prism-ui.components').component(
    'fileProgressModal',
    {
        bindings: {
            close: '&',
            dismiss: '&',
            resolve: '<'
        },
        controller: FileProgressModalComponent,
        templateUrl: 'components/modal/fileProgressModal/file-progress-modal-template.html'
    });
